export default __webpack_public_path__ + "static/media/img-0674-albania-premium-face.c48db689.png";